/**************************************************************************************************/
/** @import Node Packages                                                                        **/
/**************************************************************************************************/
import { defineComponent } from 'vue'

/**************************************************************************************************/
/** @import Mixins                                                                               **/
/**************************************************************************************************/
import MixinComponent from '@/Mixins/MixinComponent'

/**************************************************************************************************/
/** @internal Const @name StatusBar                                                              **/
/**************************************************************************************************/
const StatusBar = defineComponent(
{
	/*************************************************/
	/** @Properties                                 **/
	/*************************************************/
	name: 'StatusBar', mixins: [MixinComponent],

	/*************************************************/
	/** @Data                                       **/
	/*************************************************/
	data()
	{
		return {
			states:
			{
				elapsedTime: undefined as string | undefined,
				message: '',
				showElapsedTime: false,
				showSpinner: false,
				variant: undefined as string | undefined
			}
		}
	},

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	methods:
	{
		SetElapsedTime(showElapsedTime: boolean, startTime?: number, endTime?: number) : void
		{
			const elapsedTime = startTime !== undefined && endTime !== undefined ? ((endTime - startTime) / 1000).toFixed(2) : ''
			this.Set<StatusBarRef['states']>({ elapsedTime, showElapsedTime })
		},

		SetStatus(showSpinner: boolean, message: string, variant = undefined as string | undefined) : void
		{
			this.Set<StatusBarRef['states']>({ message, showSpinner, variant })
		}
	}
})

/**************************************************************************************************/
/** @export Component @name StatusBar                                                            **/
/**************************************************************************************************/
export default StatusBar

/**************************************************************************************************/
/** @export Type @name StatusBarRef                                                              **/
/**************************************************************************************************/
export type StatusBarRef = InstanceType<typeof StatusBar>